import { FormInstance } from 'antd';

import { initSnapSuccessAction, ISnapStore } from 'containers/Snaps/Snap/store';

import { getDateForPayload, getFormattedDataWithScores, getFormChanges } from 'utils';

import { SnapDetails } from 'codegen';
import { IDataResponse, RecursiveRequired, TRequestCallback } from 'types';

export const handleEditOCR = (
  form: FormInstance<ISnapStore['ocrFormValues']>,
  isEditDisabled: boolean,
  set: (value: boolean) => void,
) => () => {
  if (!isEditDisabled) {
    set(true);

    return form.resetFields();
  }

  return set(false);
};

export const handlePatchAllOCR = (
  ocrScores: ISnapStore['ocrScores'],
  onPatchOCRData: TRequestCallback<ISnapStore['ocrScores']>,
) => () => {
  const formattedScores = getFormattedDataWithScores(ocrScores);

  onPatchOCRData({ payload: formattedScores, callbackQueryParams: { isApprove: true } });
};

export const handlePatchOCR = (
  form: FormInstance<RecursiveRequired<ISnapStore['ocrFormValues']>>,
  ocrFormValues: ISnapStore['ocrFormValues'],
  onPatchOCRData: TRequestCallback<ISnapStore['ocrFormValues'] & ISnapStore['ocrScores']>,
) => () => {
  const changes = getFormChanges(ocrFormValues, form);

  const { retailerId, receiptTimestamp, totalTax, ...rest } = getFormattedDataWithScores<ISnapStore['ocrFormValues'] & ISnapStore['ocrScores']>(changes);

  const payload = {
    ...rest,
    ...((totalTax || typeof totalTax === 'string') && { totalTax: totalTax || null }),
    ...(receiptTimestamp && { receiptTimestamp: getDateForPayload(receiptTimestamp) }),
    retailerId,
  };

  onPatchOCRData({ payload, callbackQueryParams: { isApprove: false } });
};

export const handleSuccessPatchOCR = (
  set: (state: boolean) => void,
) => (
  { data }: IDataResponse<SnapDetails>,
) => {
  set(true);
  initSnapSuccessAction(data);
};
